var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenario-container"},[_c('img',{attrs:{"src":_vm.$imageUrl(_vm.scenario, "scenarios"),"contain":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }